import {
  Tabs,
  Typography,
  TableColumnsType,
  Button,
  Space,
  Dropdown,
  Menu,
  Modal,
  Form,
  Input,
  Divider,
  Switch,
  Tag,
  Row,
  Col,
  message,
  Spin,
  Pagination,
  Select,
  Tooltip,
} from "antd";
import { ConfirmDeleteModal } from "../../../../Components/ConfirmDeleteModal";
import { ContentWrapper } from "../../../../Components/Layout/ContentWrapper";
import { DataTable } from "../../../../Components/DataTable/DataTable";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import styles from "@styles/variables.module.scss";
import { useQuery } from "../../../../Hooks/useQuery";
import { useEffect, useState } from "react";
import { FilterDropDown } from "../../../../Components/FilterDropDown/FilterDropDown";
const { Text, Title } = Typography;
import { panelApiUrl } from "~/Utils";
import { api, panelApiBaseUrl, remove } from "../../../../../SPA/Services/api.service";
import { getFormattedDate, getKey, switchHasRole } from "@utils/CommonUtils";
import { updatedAtOf, updatedByOf } from "../../../../Utils/auditFields";
import { apiSortField } from "../../../../Utils/sortField";
import { debounce } from "lodash";
import { useNotification } from "@hooks/useNotification";
import * as Yup from "yup";
import { Formik } from "formik";
import { CategoryList } from "./WorkOrderItem/Category/CategoryList";
import { RegionList } from "./WorkOrderItem/Region/RegionList";
import { SubRegionList } from "./WorkOrderItem/SubRegion/SubRegionList";
import { VendorList } from "./WorkOrderItem/Vendor/VendorList";
import { TemplateList } from "./WorkOrderItem/Template/TemplateList";
import { settingsApi } from "../../../../Services/settings.api";
import { categoryApi, regionApi, toArray, uniqueCategories } from "../../../../Services";

/** An SOR item's categories as "Name (CODE)": every one in `categories`, or the single top-level one. */
const sorCategoriesOf = (record: any): string[] =>
  (Array.isArray(record.categories) && record.categories.length ? record.categories : [record])
    .map((entry: any) =>
      entry.categoryName && entry.categoryCode ? `${entry.categoryName} (${entry.categoryCode})` : entry.categoryName || entry.categoryCode
    )
    .filter(Boolean);

/** An SOR item's regions: the API's "Central, Northern" summary, or its price list. */
const sorRegionsOf = (record: any): string[] =>
  typeof record.regions === "string" && record.regions.trim()
    ? record.regions.split(",").map((name: string) => name.trim()).filter(Boolean)
    : Array.isArray(record.regionPrices)
    ? record.regionPrices.map((price: any) => price.regionName).filter(Boolean)
    : [];

/** The first three values, and "+N more" that lists them all on hover. */
const FirstThree = ({ values }: { values: string[] }) => {
  if (!values.length) return <>-</>;
  const shown = values.slice(0, 3).join(", ");
  if (values.length <= 3) return <>{shown}</>;
  return (
    <Tooltip
      title={values.join(", ")}
      overlayStyle={{ maxWidth: 360 }}
    >
      <span onClick={(event) => event.stopPropagation()}>
        {shown}, <Typography.Link>+{values.length - 3} more</Typography.Link>
      </span>
    </Tooltip>
  );
};

export const ManageCatalog = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const activeSubTab = query.get("subtab");
  const [activeKey, setActiveKey] = useState<any>(activeTab);
  const [activeSubKey, setActiveSubKey] = useState<any>(activeSubTab || "region");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalView, setModalView] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [form] = Form.useForm();

  // New state for SOR ID data
  const [sorIdData, setSorIdData] = useState<any[]>([]);
  const [sorIdLoading, setSorIdLoading] = useState(false);
  const [sorIdError, setSorIdError] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdOn");
  /* SOR ID's Category / Region filters, and the options they offer. */
  const [sorFilters, setSorFilters] = useState<{ categoryId?: string; regionId?: string }>({});
  const [filterCategories, setFilterCategories] = useState<any[]>([]);
  const [filterRegions, setFilterRegions] = useState<any[]>([]);
  /* The picked category's regions (null until one is picked: every region). */
  const [categoryRegions, setCategoryRegions] = useState<any[] | null>(null);
  /* Whichever of the two was picked first narrows the other's list; the one
     picked after it only filters. Neither picked: both lists are in full. */
  const [filterLead, setFilterLead] = useState<"categoryId" | "regionId" | undefined>();
  const byName = (key: string) => (a: any, b: any) => String(a[key] ?? "").localeCompare(String(b[key] ?? ""));
  /* GET /category/get-category-list, for one region when given. */
  const loadFilterCategories = (regionId?: string) =>
    categoryApi
      .byRegion(regionId)
      .then((rows: any) => setFilterCategories(uniqueCategories(toArray(rows).sort(byName("categoryName")))))
      .catch(() => undefined);
  /* The lists to offer once `lead` is picked: GET /region/get-regions-by-category for
     a lead category, the category list by region for a lead region. */
  const syncFilterOptions = (lead: "categoryId" | "regionId" | undefined, filters: { categoryId?: string; regionId?: string }) => {
    const ids = lead === "categoryId" ? filterCategories.find((entry) => entry.id === filters.categoryId)?.ids : undefined;
    if (ids) {
      setCategoryRegions([]);
      regionApi.byCategories(ids).then(setCategoryRegions);
    } else setCategoryRegions(null);
    loadFilterCategories(lead === "regionId" ? filters.regionId : undefined);
  };
  useEffect(() => {
    loadFilterCategories();
    regionApi.getAll().then((rows: any) => setFilterRegions(toArray(rows).sort(byName("regionName")))).catch(() => undefined);
  }, []);

  const [settingsData, setSettingsData] = useState<any[]>([]);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [settingsError, setSettingsError] = useState<string | null>(null);
  const [toggleConfirmVisible, setToggleConfirmVisible] = useState(false);
  const [pendingToggle, setPendingToggle] = useState<{ checked: boolean; record: any } | null>(null);
  const [isToggling, setIsToggling] = useState(false);
  
  const [limitConfirmVisible, setLimitConfirmVisible] = useState(false);
  const [pendingLimitRecord, setPendingLimitRecord] = useState<any>(null);
  const [isLimitSaving, setIsLimitSaving] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [pageStart, setPageStart] = useState<number>(0);
  const [settingsPage, setSettingsPage] = useState<number>(0);
  const [searchString, setSearchString] = useState<string>("");
  const [clearSearch, setClearSearch] = useState(false);
  const [apiUrl, setApiUrl] = useState<string>("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [uniqueId, setUniqueId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { openNotification } = useNotification();

  const [openCategoryModal, setOpenCategoryModal] = useState(false);


  /* Coming back to SOR ID shows its default list: no search, page 1, and the
     default sort (it used to keep the sort last chosen). */
  useEffect(() => {
    if (activeKey === "sorId") {
      setPage(0);
      setPageStart(0);
      setSearchString("");
      setClearSearch(true);
      setSortOrder("desc");
      setOrderBy("createdOn");
      setSorFilters({});
      fetchSorIdData("", 0, "desc", "createdOn", {});
    }
  }, [activeKey]);

  // Reset clearSearch after it's done clearing
  useEffect(() => {
    if (clearSearch) {
      const timer = setTimeout(() => setClearSearch(false), 100);
      return () => clearTimeout(timer);
    }
  }, [clearSearch]);

  // Fetch SOR ID data
  const fetchSorIdData = (
    searchText: string = "",
    currentPage: number = 0,
    currentOrder: string = sortOrder,
    currentOrderBy: string = orderBy,
    filters: { categoryId?: string; regionId?: string } = sorFilters
  ) => {
    setSorIdLoading(true);
    setSorIdError(null);

    /* A category name stands for one copy per region: with a region picked,
       that region's copy; without, every copy. */
    const category = filterCategories.find((entry) => entry.id === filters.categoryId);
    const categoryId =
      categoryRegions?.find((region) => region.id === filters.regionId)?.categoryId ??
      category?.ids.join(",") ??
      filters.categoryId;

    /* Same filter params the Category and Vendor lists send. */
    const url = `${panelApiUrl}/sorItem/get-sor-list?page=${currentPage}&size=${recordsPerPage}&searchText=${encodeURIComponent(searchText)}&order=${currentOrder}&orderBy=${apiSortField(currentOrderBy)}${
      categoryId ? `&categoryId=${encodeURIComponent(categoryId)}` : ""
    }${filters.regionId ? `&regionId=${encodeURIComponent(filters.regionId)}` : ""}`;

    setApiUrl(url);

    api
      .get(url)
      .then((res: any) => {
        const responseData = res?.data?.response?.data;

        console.log(responseData);

        const records = responseData?.records || [];

        setTotalRecords(responseData?.totalCount || 0);

        const mappedData = records.map((item: any, index: any) => ({
          key: getKey(currentPage, index),
          id: item.id,
          sorId: item.sorId,
          templateName: item.itemName,
          description: item.description,
          value: item.value,
          createdAt: getFormattedDate(item.createdOn) || "-",
          createdBy: item.createdBy || "-",
          modifiedAt: updatedAtOf(item),
          modifiedBy: updatedByOf(item),
          deleted: item.deleted,
          ...item,
        }));

        setSorIdData(mappedData);
      })
      .catch((err: any) => {
        console.error("Error fetching SOR ID data:", err);
        setSorIdData([]);
        setTotalRecords(0);
        setSorIdError("Failed to fetch SOR ID data");
        message.error("Error fetching SOR ID data");
      })
      .finally(() => {
        setSorIdLoading(false);
      });
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setClearSearch(false);
    setSearchString(value);
    setPage(0);
    setPageStart(0);
    setSorIdLoading(isLoading);

    fetchSorIdData(value, 0, sortOrder, orderBy);
  }, 1000);

  const handleTableSort = (column: any, currentSortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (currentSortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (currentSortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      } else {
        setSortOrder("desc");
        order = "desc";
      }
    }
    setOrderBy(column.dataIndex);
    setPage(0);
    setPageStart(0);
    fetchSorIdData(searchString, 0, order, column.dataIndex);
  };

  // Fetch data when tab changes to sorId
  useEffect(() => {
    if (activeKey === "sorId") {
      // fetchSorIdData is already called in the above activeKey useEffect if it changes.
      // Keeping this to prevent breaking existing flow, just passing defaults
      // fetchSorIdData("", 0, sortOrder, orderBy);
    } else if (activeKey === "settings") {
      fetchSettingsData();
    }
  }, [activeKey]);

  const fetchSettingsData = () => {
    setSettingsLoading(true);
    setSettingsError(null);

    settingsApi.getAll()
      .then((data: any) => {
        const records = data?.records || [];
        const settings = records.length > 0 ? records[0] : null;

        let mappedData: any[] = [];

        if (settings) {
          const emergency = settings.emergencyApproachEnabled || {};
          const limit = settings.contractLimit || {};
          const countryCodeObj = settings.countryCode || {};

          const emergencyVal = typeof emergency === "object" && emergency !== null ? (emergency.value ?? false) : Boolean(emergency);
          const limitVal = typeof limit === "object" && limit !== null ? (limit.value ?? 0) : (Number(limit) || 0);
          const countryCodeVal = typeof countryCodeObj === "object" && countryCodeObj !== null ? (countryCodeObj.value ?? "MY") : (countryCodeObj || "MY");

          const limitDate = limit.updatedOn ? new Date(limit.updatedOn).getTime() : 0;
          const countryDate = countryCodeObj.updatedOn ? new Date(countryCodeObj.updatedOn).getTime() : 0;
          const latestUpdatedObj = countryDate > limitDate ? countryCodeObj : limit;

          mappedData = [
            {
              key: "1",
              actionItem: "Emergency Approach",
              createdBy: emergency.createdBy || settings.createdBy || "-",
              createdOn: emergency.createdOn ? getFormattedDate(emergency.createdOn) : (settings.createdOn ? getFormattedDate(settings.createdOn) : "-"),
              updatedBy: emergency.updatedBy || settings.updatedBy || "-",
              updatedOn: emergency.updatedOn ? getFormattedDate(emergency.updatedOn) : (settings.updatedOn ? getFormattedDate(settings.updatedOn) : "-"),
              actionValue: emergencyVal,
              id: settings.id,
            },
            {
              key: "2",
              actionItem: "Contract Limit",
              createdBy: limit.createdBy || settings.createdBy || "-",
              createdOn: limit.createdOn ? getFormattedDate(limit.createdOn) : (settings.createdOn ? getFormattedDate(settings.createdOn) : "-"),
              updatedBy: latestUpdatedObj.updatedBy || settings.updatedBy || "-",
              updatedOn: latestUpdatedObj.updatedOn ? getFormattedDate(latestUpdatedObj.updatedOn) : (settings.updatedOn ? getFormattedDate(settings.updatedOn) : "-"),
              actionValue: limitVal,
              originalValue: limitVal,
              countryCode: countryCodeVal,
              originalCountryCode: countryCodeVal,
              id: settings.id,
            },
          ];
        }

        setSettingsData(mappedData);
      })
      .catch((err: any) => {
        console.error("Error fetching settings data:", err);
        setSettingsError("Failed to fetch settings data");
        message.error("Error fetching settings data");
      })
      .finally(() => {
        setSettingsLoading(false);
      });
  };

  const menuClick = (key: string, record: { [key in string]: any }) => {
    if (key === "edit") {
      navigate(`/workorder-manage-catalog/sorid-edit?id=${record?.id}`);
    } else if (key === "delete") {
      setDeleteModal(true);
      setUniqueId(record?.id);
    }
  };

  const handleDelete = () => {
    setIsLoading(true);
    remove(`${panelApiUrl}/sorItem/${uniqueId}`)
      .then((res: any) => {
        fetchSorIdData(searchString, page, sortOrder, orderBy);
        setIsLoading(false);
        openNotification({
          title: "Success",
          message: res.message,
          type: "success",
        });
        setDeleteModal(false);
        console.log(res);
      })
      .catch((err: any) => {
        setIsLoading(false);
        openNotification({
          title: err,
          message: err.message,
          type: "error",
        });
        setDeleteModal(false);
        console.log(err);
      });
  };

  const handleEmergencyApproachToggle = (checked: boolean, record: any) => {
    setToggleConfirmVisible(true);
    setPendingToggle({ checked, record });
  };

  const handleConfirmToggle = () => {
    if (!pendingToggle) return;
    setIsToggling(true);

    const contractLimitRow = settingsData.find((item) => item.actionItem === "Contract Limit");
    const currentLimit = contractLimitRow
      ? typeof contractLimitRow.actionValue === "number"
        ? contractLimitRow.actionValue
        : Number(contractLimitRow.actionValue) || 0
      : 0;

    const countryCode = "MY"; // RM MYR only, for now

    const payload = {
      emergencyApproachEnabled: pendingToggle.checked,
      contractLimit: currentLimit,
      countryCode: countryCode,
      /* The request schema carries both spellings. */
      currencyCode: countryCode,
    };

    settingsApi
      .update(pendingToggle.record.id, payload)
      .then((res: any) => {
        message.success("Emergency Approach setting updated successfully");
        fetchSettingsData();
      })
      .catch((err: any) => {
        console.error("Error updating settings:", err);
        message.error(err?.message || "Failed to update Emergency Approach setting");
      })
      .finally(() => {
        setIsToggling(false);
        setToggleConfirmVisible(false);
        setPendingToggle(null);
      });
  };

  const handleContractLimitClick = (record: any) => {
    setPendingLimitRecord(record);
    setLimitConfirmVisible(true);
  };

  const handleConfirmLimit = () => {
    if (!pendingLimitRecord) return;
    setIsLimitSaving(true);

    const contractLimitRow = settingsData.find((item) => item.key === pendingLimitRecord.key);
    const currentLimit = contractLimitRow
      ? typeof contractLimitRow.actionValue === "number"
        ? contractLimitRow.actionValue
        : Number(contractLimitRow.actionValue) || 0
      : 0;
    const countryCode = "MY"; // RM MYR only, for now

    const emergencyRow = settingsData.find((item) => item.actionItem === "Emergency Approach");
    const emergencyApproachEnabled = emergencyRow ? Boolean(emergencyRow.actionValue) : false;

    const payload = {
      emergencyApproachEnabled: emergencyApproachEnabled,
      contractLimit: currentLimit,
      countryCode: countryCode,
      /* The request schema carries both spellings. */
      currencyCode: countryCode,
    };

    settingsApi
      .update(pendingLimitRecord.id, payload)
      .then((res: any) => {
        message.success("Contract Limit setting updated successfully");
        fetchSettingsData();
      })
      .catch((err: any) => {
        console.error("Error updating settings:", err);
        message.error(err?.message || "Failed to update Contract Limit setting");
      })
      .finally(() => {
        setIsLimitSaving(false);
        setLimitConfirmVisible(false);
        setPendingLimitRecord(null);
      });
  };

  const tableSorActions = {
    callback: menuClick,
    items: [
      {
        label: (
          <Typography.Text
            type="secondary"
            style={{ color: styles?.primary }}
          >
            <Space>
              <Icon
                icon="akar-icons:edit"
                inline
                fontSize={16}
                style={{ color: styles?.primary }}
              />
              Edit
            </Space>
          </Typography.Text>
        ),
        key: "edit",
      },
      {
        label: (
          <Typography.Text type="danger">
            <Space>
              <Icon
                icon="fluent:delete-48-regular"
                inline
                fontSize={16}
              />
              Delete
            </Space>
          </Typography.Text>
        ),
        key: "delete",
      },
    ],
  };

  const sorIdColumns: TableColumnsType = [
    {
      title: "SOR ID",
      dataIndex: "sorId",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "sorId" ? "ascend" : sortOrder === "desc" && orderBy === "sorId" ? "descend" : undefined,
    },
    {
      title: "Item Name",
      dataIndex: "itemName",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "itemName" ? "ascend" : sortOrder === "desc" && orderBy === "itemName" ? "descend" : undefined,
    },
    {
      title: "UOM",
      dataIndex: "uom",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "uom" ? "ascend" : sortOrder === "desc" && orderBy === "uom" ? "descend" : undefined,
      render: (value: any) => value || "-",
    },
    {
      /* v2.1: an SOR item belongs to a category and is priced per region. */
      title: "Category",
      dataIndex: "categoryName",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "categoryName" ? "ascend" : sortOrder === "desc" && orderBy === "categoryName" ? "descend" : undefined,
      render: (_value: any, record: any) => <FirstThree values={sorCategoriesOf(record)} />,
    },
    {
      title: "Region",
      dataIndex: "regions",
      render: (_value: any, record: any) => <FirstThree values={sorRegionsOf(record)} />,
    },
    {
      title: "Created At",
      dataIndex: "createdOn",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "createdOn" ? "ascend" : sortOrder === "desc" && orderBy === "createdOn" ? "descend" : undefined,
      render: (value: any) => getFormattedDate(value) || "-",
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "createdBy" ? "ascend" : sortOrder === "desc" && orderBy === "createdBy" ? "descend" : undefined,
    },
    {
      title: "Updated At",
      dataIndex: "updatedOn",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "updatedOn" ? "ascend" : sortOrder === "desc" && orderBy === "updatedOn" ? "descend" : undefined,
      render: (value: any) => getFormattedDate(value) || "-",
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      sorter: true,
      sortOrder: sortOrder === "asc" && orderBy === "updatedBy" ? "ascend" : sortOrder === "desc" && orderBy === "updatedBy" ? "descend" : undefined,
    },
  ];

  const settingColumns: TableColumnsType = [
    { title: "Action Items", dataIndex: "actionItem", sorter: (a: any, b: any) => (a.actionItem || "").localeCompare(b.actionItem || "") },
    {
      /* Whether the setting is in force: the toggle for Emergency Approach,
         and a limit above zero for Contract Limit. */
      title: "Status",
      dataIndex: "actionValue",
      render: (value: any, record: any) => {
        const active =
          record.actionItem === "Emergency Approach" ? Boolean(value) : Number(value) > 0;
        return <Tag color={active ? "success" : "default"}>{active ? "Active" : "Inactive"}</Tag>;
      },
    },
    { title: "Created By", dataIndex: "createdBy", sorter: (a: any, b: any) => (a.createdBy || "").localeCompare(b.createdBy || "") },
    { title: "Created At", dataIndex: "createdOn", sorter: (a: any, b: any) => new Date(a.createdOn || "").getTime() - new Date(b.createdOn || "").getTime() },
    { title: "Updated By", dataIndex: "updatedBy", sorter: (a: any, b: any) => (a.updatedBy || "").localeCompare(b.updatedBy || "") },
    { title: "Updated On", dataIndex: "updatedOn", sorter: (a: any, b: any) => new Date(a.updatedOn || "").getTime() - new Date(b.updatedOn || "").getTime() },
    {
      title: "Action",
      dataIndex: "actionValue",
      render: (value: any, record: any) => {
        if (record.actionItem === "Emergency Approach") {
          return (
            <Switch
              checked={Boolean(value)}
              loading={isToggling && pendingToggle?.record?.id === record.id}
              onChange={(checked) => handleEmergencyApproachToggle(checked, record)}
            />
          );
        } else if (record.actionItem === "Contract Limit") {
          /* RM MYR only, for now — not a choice. */
          return (
            <Input.Group
              compact
              style={{ display: "flex", alignItems: "center", width: 250 }}
            >
              <Input
                addonBefore="RM MYR"
                style={{ flex: "100%" }}
                value={value}
                onChange={(e) => {
                  const newData = [...settingsData];
                  const index = newData.findIndex((item) => item.key === record.key);
                  if (index > -1) {
                    newData[index].actionValue = e.target.value;
                    setSettingsData(newData);
                  }
                }}
                onBlur={(e) => {
                  const currentValue = e.target.value;
                  if (String(currentValue) !== String(record.originalValue)) {
                    handleContractLimitClick(record);
                  }
                }}
                onPressEnter={(e: any) => {
                  const currentValue = e.target.value;
                  if (String(currentValue) !== String(record.originalValue)) {
                    handleContractLimitClick(record);
                  }
                }}
              />
            </Input.Group>
          );
        }
        return null;
      },
    },
  ];

  // Work order table columns
  const workOrderColumns: TableColumnsType = [
    { title: "Item", dataIndex: "item", sorter: (a: any, b: any) => (a.item || "").localeCompare(b.item || "") },
    { title: "Category", dataIndex: "category", sorter: (a: any, b: any) => (a.category || "").localeCompare(b.category || "") },
    { title: "Quantity", dataIndex: "quantity", sorter: (a: any, b: any) => (a.quantity || 0) - (b.quantity || 0) },
    { title: "Unit Price", dataIndex: "price", sorter: (a: any, b: any) => (a.price || "").localeCompare(b.price || "") },
    {
      title: "",
      dataIndex: "actions",
      width: 60,
      render: (_: any, record: any) => (
        <Space>
          <Typography.Text
            type="secondary"
            style={{ color: styles?.primary, cursor: "pointer" }}
            onClick={() => {
              setSelectedRecord(record);
              setModalView(true);
            }}
          >
            View
          </Typography.Text>
        </Space>
      ),
    },
  ];

  const workOrderMockData: any = [
    { key: "w1", item: "Concrete", category: "Materials", quantity: 10, price: "$120" },
    { key: "w2", item: "Crane Rental", category: "Equipment", quantity: 2, price: "$800" },
    { key: "w3", item: "Electrician", category: "Labor", quantity: 40, price: "$45" },
  ];

  const workOrderSubTabs: any = [
    /* Figma order: Region, Sub Region, Categories, Vendor — Region opens first. */
    { label: "Region", key: "region", children: <RegionList /> },
    { label: "Sub Region", key: "subRegion", children: <SubRegionList /> },
    { label: "Categories", key: "categories", children: <CategoryList /> },
    { label: "Vendor", key: "vendor", children: <VendorList /> },
  ];

  const items: any = [
    {
      label: "Template",
      key: "template",
      children: <TemplateList />,
    },
    {
      label: "Work Order Items",
      key: "workOrderItems",
      children: (
        <Tabs
          destroyInactiveTabPane={true}
          items={workOrderSubTabs}
          onChange={(key) => {
            setActiveSubKey(key);
            navigate(`?activeTab=workOrderItems&subtab=${key}`, { replace: true });
          }}
          activeKey={activeSubKey}
        />
      ),
    },
    {
      label: "SOR ID",
      key: "sorId",
      children: (
        <>
          {sorIdLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <Spin size="large" />
            </div>
          ) : sorIdError ? (
            <Typography.Text type="danger">{sorIdError}</Typography.Text>
          ) : (
            <>
              <DataTable
                searchPlaceholderText="Search by SOR ID/item name"
                searchQuery={searchString}
                hideExport={false}
                exportFileName="SOR_ID"
                exportApiUrl={apiUrl}
                inputDisable={sorIdLoading}
                totalRecords={totalRecords}
                recordsPerPage={recordsPerPage}
                clearStringSearch={clearSearch}
                onSearchChange={handleSearchChange}
                multiSelect={true}
                isPagination={true}
                isServerSearchApi={true}
                columns={sorIdColumns?.map((column) => ({
                  ...column,
                  onHeaderCell: (column: any) => ({
                    onClick: () => {
                      if (column.sorter) {
                        handleTableSort(column, sortOrder);
                      }
                    },
                  }),
                }))}
                tableData={sorIdData}
                className="table-clickable"
                onClick={(record: any) => navigate(`/workorder-manage-catalog/sorid-edit?id=${record.id}&mode=view`)}
                additionalCTAToRight={true}
                tableActions={tableSorActions}
                additionalCTA={
                  <Space size={8}>
                    {(
                      [
                        ["Category", "categoryId", filterCategories, "categoryName"],
                        ["Region", "regionId", categoryRegions ?? filterRegions, "regionName"],
                      ] as const
                    ).map(([placeholder, key, options, labelKey]) => (
                      <Select
                        key={key}
                        placeholder={placeholder}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        style={{ width: 150 }}
                        value={sorFilters[key]}
                        onChange={(value?: string) => {
                          const other = key === "categoryId" ? "regionId" : "categoryId";
                          /* Clearing the lead clears both; a new lead pick drops the other's value. */
                          const lead = !value && key === filterLead ? undefined : sorFilters[other] ? filterLead : key;
                          const next: { categoryId?: string; regionId?: string } =
                            !lead ? {} : key === lead ? { [key]: value } : { ...sorFilters, [key]: value };
                          if (lead !== filterLead || key === lead) syncFilterOptions(lead, next);
                          setFilterLead(lead);
                          setSorFilters(next);
                          setPage(0);
                          setPageStart(0);
                          fetchSorIdData(searchString, 0, sortOrder, orderBy, next);
                        }}
                      >
                        {options.map((option: any) => (
                          <Select.Option
                            key={option.id}
                            value={option.id}
                          >
                            {option[labelKey]}
                          </Select.Option>
                        ))}
                      </Select>
                    ))}
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/workorder-manage-catalog/sorid-add`);
                      }}
                    >
                      <Space>
                        <Icon
                          icon="akar-icons:plus"
                          inline
                        />
                        Add
                      </Space>
                    </Button>
                  </Space>
                }
                excludeExportCols={["Action", "Updated At", "Updated By"]}
                includeExportCols={[
                  {
                    displayName: "SOR ID",
                    dataIndex: "sorId",
                    render: (value: any) => value || "-",
                  },
                  {
                    displayName: "Item Name",
                    dataIndex: "itemName",
                    render: (value: any) => value || "-",
                  },
                  {
                    displayName: "UOM",
                    dataIndex: "uom",
                    render: (value: any) => value || "-",
                  },
                  {
                    displayName: "Category",
                    dataIndex: "categoryName",
                    render: (_value: any, record: any) => sorCategoriesOf(record).join(", ") || "-",
                  },
                  {
                    displayName: "Region",
                    dataIndex: "regions",
                    render: (_value: any, record: any) => sorRegionsOf(record).join(", ") || "-",
                  },
                  {
                    displayName: "Created At",
                    dataIndex: "createdOn",
                    render: (value: any) => getFormattedDate(value) || "-",
                  },
                  {
                    displayName: "Created By",
                    dataIndex: "createdBy",
                    render: (value: any) => value || "-",
                  },
                  {
                    displayName: "Updated At",
                    dataIndex: "updatedOn",
                    render: (value: any) => getFormattedDate(value) || "-",
                  },
                  {
                    displayName: "Updated By",
                    dataIndex: "updatedBy",
                    render: (value: any) => value || "-",
                  },
                ]}
              />
              <div className="pagination">
                <Pagination
                  defaultCurrent={1}
                  current={page + 1}
                  total={totalRecords}
                  onChange={(newPage) => {
                    const startIndex = newPage - 1;

                    setPage(startIndex);
                    setPageStart(startIndex);

                    fetchSorIdData(searchString, startIndex, sortOrder, orderBy);
                  }}
                  showSizeChanger={false}
                  pageSize={10}
                />
              </div>
            </>
          )}
        </>
      ),
    },
    {
      label: "Settings",
      key: "settings",
      children: (
        <>
          {settingsLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <Spin size="large" />
            </div>
          ) : settingsError ? (
            <Typography.Text type="danger">{settingsError}</Typography.Text>
          ) : (
            <>
              <DataTable
                multiSelect={false}
                showTopBar={false}
                columns={settingColumns}
                tableData={settingsData.slice(settingsPage * 10, (settingsPage + 1) * 10)}
                isPagination={true}
              />
              <div className="pagination">
                <Pagination
                  defaultCurrent={1}
                  current={settingsPage + 1}
                  total={settingsData.length}
                  onChange={(newPage) => {
                    const startIndex = newPage - 1;
                    setSettingsPage(startIndex);
                  }}
                  showSizeChanger={false}
                  pageSize={10}
                />
              </div>
            </>
          )}
        </>
      ),
    },
  ];

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    if (key === "workOrderItems") {
      setActiveSubKey("region");
      navigate(`?activeTab=${key}&subtab=region`, { replace: true });
    } else {
      navigate(`?activeTab=${key}`, { replace: true });
    }
  };

  return (
    <>
      <ContentWrapper
        title={"Manage Catalog"}
        actionItems={
          <>
            {/* {activeKey === "template" && (
              <Button
                type="primary"
                onClick={() => navigate(`/workorder-manage-catalog/template-edit`)}
              >
                <Space>
                  <Icon
                    icon="akar-icons:plus"
                    inline
                  />
                  Add
                </Space>
              </Button>
            )} */}
            {activeKey === "contractLimit" && (
              <Button
                type="primary"
                onClick={() => setModalVisible(true)}
              >
                <Space>
                  <Icon
                    icon="akar-icons:plus"
                    inline
                  />
                  Add
                </Space>
              </Button>
            )}
          </>
        }
      >
        <Tabs
          destroyInactiveTabPane={true}
          items={items}
          onChange={handleTabChange}
          activeKey={activeKey}
        />
      </ContentWrapper>
      <Modal
        title="Add Contract Limit"
        open={modalVisible}
        maskClosable={false}
        centered
        width="30%"
        onCancel={() => {
          form.resetFields();
          setModalVisible(false);
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 6 }}>
            <Button
              onClick={() => {
                form.resetFields();
                setModalVisible(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
            >
              Add
            </Button>
          </div>
        }
      >
        <Divider style={{ margin: "-20px 0 22px", borderTop: "1px solid #d9d9d9" }} />
        <Form
          form={form}
          layout="vertical"
          initialValues={{ contractLimit: "" }}
          onFinish={(values) => {
            form.resetFields();
            setModalVisible(false);
          }}
        >
          <Form.Item
            label="Contract Limit"
            name="contractLimit"
          >
            <Input placeholder="Enter contract limit" />
          </Form.Item>
        </Form>
      </Modal>
      <ConfirmDeleteModal
        open={deleteModal}
        message="Are you sure you want to delete the SOR ID?"
        isConfirming={isLoading}
        onCancel={() => setDeleteModal(false)}
        onConfirm={handleDelete}
      />

      <Modal
        title="Confirm Action"
        open={toggleConfirmVisible}
        onOk={handleConfirmToggle}
        onCancel={() => {
          setToggleConfirmVisible(false);
          setPendingToggle(null);
        }}
        okText="Confirm"
        cancelText="Cancel"
        confirmLoading={isToggling}
        centered
        maskClosable={false}
      >
        <Typography.Text>
          Are you sure you want to change the Emergency Approach setting?
        </Typography.Text>
      </Modal>

      <Modal
        title="Confirm Action"
        open={limitConfirmVisible}
        onOk={handleConfirmLimit}
        onCancel={() => {
          /* The input writes straight into settingsData as it is typed, so
             closing the dialog left the edited figure on screen as though it
             had been saved. Cancel puts back what was last loaded. */
          setSettingsData((current: any[]) =>
            current.map((row) =>
              row.key === pendingLimitRecord?.key
                ? {
                    ...row,
                    actionValue: row.originalValue ?? row.actionValue,
                    countryCode: row.originalCountryCode ?? row.countryCode,
                  }
                : row
            )
          );
          setLimitConfirmVisible(false);
          setPendingLimitRecord(null);
        }}
        okText="Confirm"
        cancelText="Cancel"
        confirmLoading={isLimitSaving}
        centered
        maskClosable={false}
      >
        <Typography.Text>
          Are you sure you want to update the Contract Limit setting?
        </Typography.Text>
      </Modal>

    </>
  );
};
